import React, { FC, useMemo } from "react";

import { Badge, BadgeProps, OverlayTrigger, Tooltip } from "react-bootstrap";

import classNames from "classnames";

interface StatusBadgeProps extends BadgeProps {
  cellClassName?: string | string[];
  customStyle?: { [key: string]: string };
  cellValue?: string;
}

export const StatusBadge: FC<StatusBadgeProps> = ({ cellClassName, customStyle, cellValue }) => {
  const styleToApply = useMemo(() => {
    if (typeof cellClassName === "string") {
      return cellClassName && customStyle && customStyle[cellClassName];
    }
    if (Array.isArray(cellClassName)) {
      return cellClassName.map((className) => customStyle && customStyle[className]).join(" ");
    }
  }, [cellClassName, customStyle]);

  return (
    <OverlayTrigger placement="top" overlay={<Tooltip>{cellValue || "undefined"}</Tooltip>}>
      <Badge bg="none" className={classNames("b5 medium monoBlack w-100", styleToApply)}>
        {cellValue || "undefined"}
      </Badge>
    </OverlayTrigger>
  );
};
